import { useCashierText } from "./cashierText";

const tabs = ["pending", "complete", "deleted"];
export default function CashierTabs({ active, summary, onChange }) {
  const { t } = useCashierText();
  return (
    <div className="cashier-tabs" role="tablist">
      {tabs.map((key) => (
        <button
          role="tab"
          aria-selected={active === key}
          className={active === key ? "on" : ""}
          key={key}
          onClick={() => onChange(key)}
        >
          {t.tabs[key]}
          <span>{summary[key] || 0}</span>
        </button>
      ))}
    </div>
  );
}
